import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectLocale } from 'features/LanguageSelector';
import { http } from 'core/ApiClient';
import { Error } from 'core/types';
import { Routes } from 'types/types';
import { resolveApiErrors } from 'features/ApiErrors';

import { UserStateInterface } from './types';
import { setUser, resetUserState } from './reducer/userReducer';

export const useFetchUser = (userId?: string) => {
	const [data, setData] = useState<UserStateInterface | null>(null);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<Record<string, string> | null>(null);

	const dispatch = useDispatch();
	const locale = useSelector(selectLocale);

	useEffect(() => {
		dispatch(resetUserState());
		if (userId) {
			const fetchData = async () => {
				setIsLoading(true);
				const response = await http.get<UserStateInterface>(
					`${Routes.Users}/${userId}`
				);
				setIsLoading(false);
				setData(response);
				setError(null);
				dispatch(setUser(response));
			};
			fetchData().catch((e: Error) => {
				setError(resolveApiErrors(e.cause.violations, {}, locale).globalErrors);
				setIsLoading(false);
			});
		}
	}, []);

	return { data, isLoading, error };
};
